import React, { useState, useEffect, useCallback } from "react"
import { Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import queryString from "query-string"
import { ROUTES } from "../../common/utils"
import Loader from "../../common/Loader"
import { API } from "../../api"

function SubscriptionCancel(props) {
  const [cancelling, setCancelling] = useState(true)

  const params = queryString.parse(props.location.search)
  const subsID = params.subscription_id
  const { showAlert } = props

  const cancelApproval = useCallback(
    async () => {
      try {
        await API.post(
          "accounts/paypal/cancel_approval",
          JSON.stringify({ subscription_id: subsID })
        )
        showAlert &&
          showAlert({
            message: "Upgrade cancelled.",
            type: "warning",
            consumer: "admin"
          })
        setCancelling(false)
      } catch (error) {
        console.log(error)
      }
    },
    [subsID, showAlert]
  )

  useEffect(
    () => {
      cancelApproval()
    },
    [cancelApproval]
  )

  return cancelling ? <Loader /> : <Redirect to={ROUTES.ADMIN} />
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  null,
  mapDispatchToProps
)(SubscriptionCancel)
